import React from "react";
import { Cog6ToothIcon } from "@heroicons/react/24/outline";

function SettingsPage() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Sistem Ayarları</h1>
        <p className="text-gray-600">Platform ayarlarını yönetin</p>
      </div>

      <div className="card">
        <div className="card-body text-center py-12">
          <Cog6ToothIcon className="w-16 h-16 text-gray-300 mx-auto mb-4" />
          <h3 className="text-lg font-medium text-gray-900 mb-2">
            Sistem Ayarları Geliştiriliyor
          </h3>
          <p className="text-gray-600">Bu sayfa geliştirilme aşamasındadır</p>
        </div>
      </div>
    </div>
  );
}

export default SettingsPage;
